<div class="container-fluid">
    <div class="row no-gutter">
        <div class="col-md-3 d-none d-md-flex bg-image">
            <div class="container"></div>
        </div>
        <div class="col-md-6">
            <div class="login d-flex align-items-center py-5">
                <div class="container">
                    <img src="assets/top2.png" class="img resptilt" />
                    <div class="row">
                        <img src="../../../assets/logo.png" style="width:275px;margin: auto;" />
                    </div>
                    <div class="row" *ngIf="this.istrue">
   <p  style="text-align: center; color: red;">{{this.recievemessage.message}}</p>
                    </div>
                    <div class="row">
                        <div class="col-lg-7 col-xl-6 mx-auto">
                            <div class="text-danger text-center mb-3">
                                <h5 style="margin-top: 5px;"></h5>
                            </div>
                            <form action="" method="post" name="login">
                                <div class="form-group">
                                    <input type="text" name="name" class="form-control my-input" id="name" placeholder="Name">
                                </div>

                                <div class="form-group">
                                    <input type="number" min="0" name="phone" id="phone" class="form-control my-input" placeholder="Phone">
                                </div>
                                <div class="form-group">
                                    <input type="email" name="email" class="form-control my-input" id="email" placeholder="Email">
                                </div>
                                <div class="text-center ">
                                    <button routerLink="/patotp" type="submit" class=" btn btn-block send-button tx-tfm">Create Account</button>
                                </div>
                                <div class="col-md-12 ">

                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3 d-none d-md-flex bg-white">

        </div>
    </div>
</div>





<!-- <body>
    <div class="container">
        <div class="col-md-6 mx-auto text-center">
            <div class="header-title">

            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mx-auto">
                <div class="myform form ">
                    <img src="../../../assets/logo.png" style="width:275px;margin: auto;" />

                    <form action="" method="post" name="login">
                        <div class="form-group">
                            <input type="text" name="name" class="form-control my-input" id="name" placeholder="Name">
                        </div>
                        <div class="form-group">
                            <input type="email" name="email" class="form-control my-input" id="email" placeholder="Email">
                        </div>
                        <div class="form-group">
                            <input type="number" min="0" name="phone" id="phone" class="form-control my-input" placeholder="Phone">
                        </div>
                        <div class="text-center ">
                            <button type="submit" class=" btn btn-block send-button tx-tfm">Create Your Free Account</button>
                        </div>
                        <div class="col-md-12 ">

                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</body> -->